import { useMemo } from "react";
import useEventDefinition from "hooks/useEventDefinition";
const useEventsAdditionalData = ({ eventData, definitionId = null }) => {
  var _a, _b;
  const { data, isLoading: isLoadingEventDefinition } = useEventDefinition(
    definitionId != null ? definitionId : eventData == null ? void 0 : eventData.event_definition_id
  );
  const meta = useMemo(
    () => eventData ? {
      context: {
        event_definitions: {
          [eventData.event_definition_id]: data.eventDefinition
        }
      }
    } : null,
    [eventData, data.eventDefinition]
  );
  const eventDefinitionEventProcedureId = (_b = (_a = data == null ? void 0 : data.eventDefinition) == null ? void 0 : _a.event_procedure) != null ? _b : "";
  return {
    meta,
    isLoadingEventDefinition,
    eventDefinitionEventProcedureId
  };
};
export default useEventsAdditionalData;
